import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSidebar } from '../../context/SidebarContext';

export default function SidebarNavLink({
  to,
  label,
  icon: Icon,
  end = false,
  onClick,
  className = '',
  account = false,
  children,
}) {
  const { effectiveCollapsed } = useSidebar();

  const linkClass = account ? 'app-sidebar-account' : 'app-sidebar-nav-link';
  const activeClass = account
    ? 'app-sidebar-account--active'
    : 'app-sidebar-nav-link--active';

  return (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      title={effectiveCollapsed ? label : undefined}
      data-tooltip={effectiveCollapsed ? label : undefined}
      className={({ isActive }) =>
        `${linkClass}${isActive ? ` ${activeClass}` : ''}${className ? ` ${className}` : ''}`.trim()
      }
    >
      {children ?? (
        <>
          <Icon className="app-sidebar-nav-icon" strokeWidth={1.75} />
          <span className="app-sidebar-nav-label">{label}</span>
        </>
      )}
    </NavLink>
  );
}
